export default "__VITE_ASSET__CHzSWl5A__"